module.exports = new __parcel__URL__("fur_chip_icon.ec47273f.png").toString();